export const getHtml = (): HTMLHtmlElement => document.getElementsByTagName('html')[0];
